// Report page components by reportCatalog id, for /crm/reports My view (ReportCardsHost).
import MarketingReports from './MarketingReports';
import SalesReports from './SalesReports';
import LostLeadsReports from './LostLeadsReports';
import LeadPortalReports from './LeadPortalReports';
import LostClientsReports from './LostClientsReports';
import ClientSatisfaction from './ClientSatisfaction';
import ClientPurchases from './ClientPurchases';
import BreakthroughsReports from './BreakthroughsReports';
import MeetingsReports from './crm/meetings-reports';
import CallReports from './CallReports';
import CompanyGoals from './CompanyGoals';
import TechnologyReports from './TechnologyReports';
import StaffActivity from './crm/StaffActivity';
import FinanceReports from './FinanceReports';
import SummitOverview from './SummitOverview';
import ConferencesReports from './ConferencesReports';

export const REPORT_PAGE_COMPONENTS = {
  marketing: MarketingReports,
  sales: SalesReports,
  'lost-leads': LostLeadsReports,
  'lead-portal': LeadPortalReports,
  'lost-clients': LostClientsReports,
  'client-satisfaction': ClientSatisfaction,
  'client-purchases': ClientPurchases,
  breakthroughs: BreakthroughsReports,
  meetings: MeetingsReports,
  'call-reports': CallReports,
  goals: CompanyGoals,
  technology: TechnologyReports,
  'staff-activity': StaffActivity,
  finance: FinanceReports,
  summit: SummitOverview,
  conferences: ConferencesReports,
};
